import React from 'react';
import { Icon, IconColor, IconName } from 'app/common/components/controls';
import styles from './TemplatesTypeformBanner.less';
import { usesEnglish } from '@trello/locale';

const submitTemplateUrl = 'https://trello.typeform.com/to/YxMGeV';

export const TemplatesTypeformBanner: React.FunctionComponent = () => {
  if (usesEnglish()) {
    return (
      <div className={styles.bannerContainer}>
        <div className={styles.bannerMessage}>
          <div className={styles.bannerHeader}>
            Show the world how you Trello!
          </div>
          <a
            className={styles.bannerText}
            key="submitTemplateLink"
            href={submitTemplateUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Submit a Template
          </a>
        </div>
        <div className={styles.hideOverflow}>
          <div className={styles.bannerAccent} />
          <div className={styles.trelloLogo} />
          <Icon
            className={styles.trelloTemplateIcon}
            name={IconName.TemplateBoard}
            color={IconColor.Light}
            medium
          />
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
